'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENUM_RIGHT = exports.ENUM_LEFT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bindAll = require('lodash/bindAll');

var _bindAll2 = _interopRequireDefault(_bindAll);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enums
var ENUM_LEFT = -1;
var ENUM_RIGHT = 1;

var BaseStepper = function (_React$Component) {
  _inherits(BaseStepper, _React$Component);

  function BaseStepper(props) {
    _classCallCheck(this, BaseStepper);

    var _this = _possibleConstructorReturn(this, (BaseStepper.__proto__ || Object.getPrototypeOf(BaseStepper)).call(this, props));

    (0, _bindAll2.default)(_this, ['startStepCount', 'stopStepCount', 'renderHandle']);
    return _this;
  }

  _createClass(BaseStepper, [{
    key: 'startStepCount',
    value: function startStepCount(direction) {
      var _this2 = this;

      this.stopStepCount(direction, false);
      this.timeoutId = window.setTimeout(function () {
        // Start an interval for the stepper to trigger infinitely.
        _this2.intervalId = window.setInterval(function () {
          try {
            // Is the button disabled ?
            if (_this2.props.isHandleDisabled(direction)) {
              // Stop the step count.
              _this2.stopStepCount(direction);
            } else {
              // Handle the step in an interval.
              _this2.props.onHandleChange(direction, true);
            }
          } catch (e) {
            // End the click now or the interval will run infinitely.
            _this2.stopStepCount(direction);
          }
        }, 100);
      }, 300);
    }
  }, {
    key: 'stopStepCount',
    value: function stopStepCount(direction, finalIncrement) {
      // Do we need one final increment ?
      if (finalIncrement === true) {
        this.props.onHandleChange(direction, false);
      }

      // Clear the timeouts and intervals.
      window.clearInterval(this.intervalId);
      window.clearTimeout(this.timeoutId);
      delete this.intervalId;
      delete this.timeoutId;
    }
  }, {
    key: 'renderHandle',
    value: function renderHandle(direction) {
      var classes = (0, _classnames2.default)('stepper-handle', {
        'stepper-handle-left': direction === ENUM_LEFT,
        'stepper-handle-right': direction === ENUM_RIGHT,
        disabled: this.props.isHandleDisabled(direction)
      });

      // TODO should be a button and should not bind
      /* eslint-disable react/jsx-no-bind, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
      return _react2.default.createElement('div', {
        onMouseDown: this.startStepCount.bind(this, direction),
        onTouchStart: this.startStepCount.bind(this, direction),
        onClick: this.stopStepCount.bind(this, direction, true),
        onMouseLeave: this.stopStepCount.bind(this, direction),
        onTouchEnd: this.stopStepCount.bind(this, direction),
        className: classes
      });
      /* eslint-enable react/jsx-no-bind, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    }
  }, {
    key: 'render',
    value: function render() {
      var stepperContent = this.props.hasNumericInput ? _react2.default.createElement('input', {
        className: 'stepper-content',
        value: this.props.value,
        type: 'tel',
        onClick: this.props.onTextInputClick,
        onChange: this.props.onTextInputChange,
        onBlur: this.props.onTextInputBlur,
        onFocus: this.props.onTextInputFocus,
        onKeyPress: this.props.onKeyPress
      }) : _react2.default.createElement(
        'div',
        { className: 'stepper-content' },
        this.props.value
      );

      return _react2.default.createElement(
        'div',
        { className: 'nw-stepper' },
        this.renderHandle(ENUM_LEFT),
        stepperContent,
        this.renderHandle(ENUM_RIGHT)
      );
    }
  }]);

  return BaseStepper;
}(_react2.default.Component);

// Export the left and right enums


BaseStepper.displayName = 'BaseStepper';
BaseStepper.propTypes = {
  hasNumericInput: _propTypes2.default.bool,
  isHandleDisabled: _propTypes2.default.func,
  onHandleChange: _propTypes2.default.func.isRequired,
  onKeyPress: _propTypes2.default.func,
  onTextInputBlur: _propTypes2.default.func,
  onTextInputChange: _propTypes2.default.func,
  onTextInputClick: _propTypes2.default.func,
  onTextInputFocus: _propTypes2.default.func,
  value: _propTypes2.default.any.isRequired // eslint-disable-line react/forbid-prop-types
};
BaseStepper.defaultProps = {
  hasNumericInput: false,
  isHandleDisabled: function isHandleDisabled() {},
  onKeyPress: function onKeyPress() {},
  onTextInputBlur: function onTextInputBlur() {},
  onTextInputChange: function onTextInputChange() {},
  onTextInputClick: function onTextInputClick() {},
  onTextInputFocus: function onTextInputFocus() {}
};
exports.default = BaseStepper;
exports.ENUM_LEFT = ENUM_LEFT;
exports.ENUM_RIGHT = ENUM_RIGHT;
BaseStepper.__docgenInfo = {
  'description': '',
  'displayName': 'BaseStepper',
  'props': {
    'hasNumericInput': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'isHandleDisabled': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'onHandleChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'onKeyPress': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'onTextInputBlur': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'onTextInputChange': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'onTextInputClick': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'onTextInputFocus': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'value': {
      'type': {
        'name': 'any'
      },
      'required': true,
      'description': ''
    }
  }
};